// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"z7-z"};